import GatewayConfig from 'app/src/data/models/GatewayConfig';
import RetailCollection from 'app/src/data/models/RetailCollection';
import URLHelper from 'app/src/data/models/utils/URLHelper';

export default class GatewayConfigCollection extends RetailCollection {
  get model() {
    return GatewayConfig;
  }

  /**
   * Return the REST url for collection of GatewayConfig models
   * @returns {string} the url representing the REST endpoint
   */
  url() {
    return URLHelper.getAccountURL('/GatewayConfig.json');
  }

  /**
   * Overridden to parse out superfluous json that the current LSCloud returns us
   * @param response
   * @returns {*}
   */
  parse(response) {
    // response.GatewayConfig is an array of the GatewayConfig structures we want.
    // Return it directly if an object is found; otherwise return an empty array
    // and let Backbone handle it
    return response.GatewayConfig || [];
  }
}
